const menu = {
  key: "taxTable",
  route: "/legacy/tax-table",
  label: "sidebar.taxTable",
  icon: "faPercentage",
  group: "finance",
  order: 10,
  permission: "legacy.taxTable.read"
};

export default menu;